import React, { useRef } from "react";
import { Table } from "react-bootstrap";
import {
  DownloadTableExcel,
  useDownloadExcel,
} from "react-export-table-to-excel";

const StatusListDateWiseExport = ({ reportData }) => {
  const tableRef = useRef(null);
  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "Students List",
    sheet: "StudentsList",
  });

  return (
    <div>
      <button className="btn btn-primary mx-2" onClick={onDownload}>
        {" "}
        Export{" "}
      </button>

      <Table ref={tableRef} style={{ display: "none" }}>
        <thead>
          <tr id="tbl">
            <td style={{ color: "black", textAlign: "start" }}>
              <b style={{ borderBottom: "1px solid black" }}>Sr.</b>
            </td>
            <td style={{ color: "black" }}>
              <b style={{ borderBottom: "1px solid black" }}>Adm-Id</b>
            </td>
            <td style={{ textAlign: "start", color: "black" }}>
              <b style={{ borderBottom: "1px solid black" }}>Student Name</b>
            </td>
            <td style={{ textAlign: "start", color: "black" }}>
              <b style={{ borderBottom: "1px solid black" }}>Father Name</b>
            </td>
            <td style={{ color: "black", textAlign: "start" }}>
              <b style={{ borderBottom: "1px solid black" }}>Mobile No</b>
            </td>
            <td style={{ color: "black" }}>
              <b style={{ borderBottom: "1px solid black" }}>DOB</b>
            </td>
            <td style={{ color: "black" }}>
              <b style={{ borderBottom: "1px solid black" }}>Gender</b>
            </td>
            <td style={{ color: "black" }}>
              <b style={{ borderBottom: "1px solid black" }}>Address</b>
            </td>
          </tr>
        </thead>

        <tbody>
          {reportData.map((mainitem, index) => (
            <React.Fragment key={index}>
              <tr>
                <td
                  colSpan={8}
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "15px",
                  }}
                  className="text-start"
                >
                  {mainitem.Campus}
                </td>
              </tr>
              {mainitem.Courses &&
                Array.isArray(mainitem.Courses) &&
                mainitem.Courses.length > 0 &&
                mainitem.Courses.map((item, index) =>
                  item.Classes.map((subitem, subIndex) =>
                    subitem.Sections.map((subsubitem, subsubIndex) => (
                      <React.Fragment
                        key={`${index}-${subIndex}-${subsubIndex}`}
                      >
                        {Array.isArray(subsubitem.Students) &&
                          subsubitem.Students.length > 0 &&
                          subsubitem.Students.length > 0 && (
                            <tr>
                              <th></th>
                              <th
                                colSpan={3}
                                style={{
                                  color: "black",
                                  fontWeight: "bold",
                                  fontSize: "15px",
                                }}
                                className="text-center"
                              >
                                Course: &nbsp; {item?.Course?.name}
                              </th>
                              <th
                                colSpan={2}
                                style={{
                                  color: "black",
                                  fontWeight: "bold",
                                  fontSize: "15px",
                                }}
                                className="text-center"
                              >
                                Class: &nbsp; {subitem?.Class}
                              </th>
                              <th
                                colSpan={2}
                                style={{
                                  color: "black",
                                  fontWeight: "bold",
                                  fontSize: "15px",
                                }}
                                className="text-start"
                              >
                                Section: &nbsp; {subsubitem?.Section?.name}
                              </th>
                            </tr>
                          )}
                        {subsubitem.Students.length > 0 &&
                          subsubitem.Students.map((student, i) => (
                            <tr id="tbl" key={i}>
                              <td
                                style={{ color: "black" }}
                                className="text_align_start"
                              >
                                {i + 1}
                              </td>
                              <td
                                style={{ color: "black" }}
                                className="text_align_start"
                              >
                                {student.admission_id}
                              </td>
                              <td
                                style={{ color: "black" }}
                                className="text_align_start"
                              >
                                {student.name}
                              </td>
                              <td
                                style={{ color: "black" }}
                                className="text_align_start"
                              >
                                {student.father_name}
                              </td>
                              <td
                                style={{ color: "black" }}
                                className="text_align_start"
                              >
                                {student.mobile_no}
                              </td>
                              <td
                                style={{ color: "black" }}
                                className="text_align_start"
                              >
                                {student.dob}
                              </td>
                              <td
                                style={{ color: "black" }}
                                className="text_align_start"
                              >
                                {student.gender}
                              </td>
                              <td
                                style={{ color: "black" }}
                                className="text_align_start"
                              >
                                {student.address}
                              </td>
                            </tr>
                          ))}
                      </React.Fragment>
                    ))
                  )
                )}
            </React.Fragment>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default StatusListDateWiseExport;
